import {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
//mui
import {Box} from '@mui/material';
//store
import {useAppSelector} from '@/store/hooks';
import {getCurrentEventSelector, getEventsSelector} from '@/store/organization-event';
//icons
import {ReactComponent as NoteIcon} from '@/assets/icons/note.svg';
import {ReactComponent as ImportIcon} from '@/assets/icons/import-file.svg';
import {ReactComponent as ErrorIcon} from '@/assets/icons/danger.svg';
//components
import EmptyContent from '@/shared/components/Table/EmptyContent';
import ContactListTable from '@/components/Organization/Profile/ContactList/ContactListTable';
import Loader from '@/shared/components/Loader';
//helpers
import {getDefaultRequestBody, getErrorMessage} from '@/utils/helpers';
//constants
import {IMPORT_CONTACT_LIST, ORGANIZATION_ID, ZERO} from '@/utils/constants';
//service
import {OrganizationContactService} from '@/utils/services';
//types
import {IOrganizationContactsListResponse} from '@/utils/types';
//styles
import {profileContactListStyle} from './ProfileContactList.styles';
import Modal from '@/shared/components/Modal';
import ImportContactList from '@/components/Organization/Profile/ContactList/ContactListTable/ImportContactList';
import {useGetOrganizationId} from '@/utils/hooks';

const ProfileContactList = () => {
	const events = useAppSelector(getEventsSelector);

	const [isDataLoaded, setIsDataLoaded] = useState(false);
	const [isShowImportListModal, setIsShowImportListModal] = useState(false);
	const [isExitModalOpen, setIsExitModalOpen] = useState(false);

	const [contactsList, setContactsList] = useState<IOrganizationContactsListResponse | null>(null);

	const organizationId = useGetOrganizationId();
	const currentEvent = useAppSelector(getCurrentEventSelector);

	useEffect(() => {
		if (currentEvent && organizationId) {
			const getContactsListData = async () => {
				setIsDataLoaded(false);

				try {
					const reqBody = getDefaultRequestBody(organizationId, ORGANIZATION_ID);
					const contactsListData = await OrganizationContactService.getContactsList(reqBody);
					setContactsList(contactsListData.data);
				} catch (error) {
					toast.error(getErrorMessage(error));
				} finally {
					setIsDataLoaded(true);
				}
			};

			getContactsListData();
		} else if (events?.length === ZERO) setIsDataLoaded(true);
	}, [currentEvent, isShowImportListModal]);

	const handleExitModalChange = () => setIsExitModalOpen(!isExitModalOpen);

	return (
		<Box sx={profileContactListStyle.wrapper}>
			{isDataLoaded ? (
				currentEvent && contactsList?.data.length ? (
					<ContactListTable contactsList={contactsList} />
				) : (
					<EmptyContent
						title="No contacts yet"
						icon={NoteIcon}
						buttonTitle={IMPORT_CONTACT_LIST}
						buttonIcon={ImportIcon}
						onModalChange={() => setIsShowImportListModal(true)}
						parentClassName={profileContactListStyle.emptyContent}
					/>
				)
			) : (
				<Loader parentClassName={profileContactListStyle.loader} size={50} />
			)}

			{isShowImportListModal && (
				<ImportContactList
					onCloseModal={() => setIsShowImportListModal(false)}
					open={isShowImportListModal}
					handleErrorModal={handleExitModalChange}
				/>
			)}
			<Modal
				open={isExitModalOpen}
				onClose={handleExitModalChange}
				onSave={() => {
					handleExitModalChange();
					setIsShowImportListModal(false);
				}}
				sx={profileContactListStyle.deleteContactModal}
				title="Exit Import"
				description="Are you sure you want to exit? Your current information will not be saved."
				mainButtonTitle="Exit"
				closeButtonTitle="Cancel"
				mainIcon={<ErrorIcon />}
				color="error"
				isShowSaveButton
				isShowCloseButton
			/>
		</Box>
	);
};

export default ProfileContactList;
